import '../scss/app.scss';

// import 'bootstrap/js/dist/base-component';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';

import { Modal } from 'bootstrap';
import AOS from 'aos';
import CC from "CookieConsent";

document.addEventListener("DOMContentLoaded", () => {
    /* Animate on scroll */
    AOS.init({
        duration: 600,
        offset: 120,
        easing: 'ease-in-out',
    })
});

(function () {
    /* Contact Modal */
    var modalContainer = document.getElementById('myModal')

    if (modalContainer) {
        var myModal = new Modal(modalContainer)
        var successModal = new Modal(document.getElementById('successModal'))

        //var cf7response = document.getElementsByClassName('wpcf7-response-output')[0]

        // modalContainer.addEventListener('show.bs.modal', function (event) {
        //     cf7response.style.display = 'none'
        // })

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            
            myModal.hide()
            successModal.show()

        }, false )
    }

    /* Prealoder */
    // window.onload = function () {
    //     window.setTimeout(fadeout, 500);
    // }

    // function fadeout() {
    //     document.querySelector('.preloader').style.opacity = '0';
    //     document.querySelector('.preloader').style.display = 'none';
    // }

    /* Sticky header */
    window.onscroll = function () {
        var header_navbar = document.querySelector(".navbar-area")
        var sticky = header_navbar.offsetTop

        if (window.pageYOffset > sticky) {
            header_navbar.classList.add("sticky")
        } else {
            header_navbar.classList.remove("sticky")
        }

        // show or hide the back-top-top button
        var backToTo = document.querySelector(".scroll-top")
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            backToTo.style.display = "flex"
        } else {
            backToTo.style.display = "none"
        }
    }

    /* Highlight menu item on scroll */
    const links = document.querySelectorAll('.menu-item');
    const sections = document.querySelectorAll('.section');

    function changeLinkState() {
        let index = sections.length;

        while(--index && window.scrollY + 61 < sections[index].offsetTop) {}
        
        links.forEach((link) => link.classList.remove('current-menu-item'));
        links[index].classList.add('current-menu-item');
    }

    changeLinkState();
    window.addEventListener('scroll', changeLinkState);

    /* Video in modal */
    let modal = document.getElementById('play-video-modal')
    let bsModal = new Modal(modal)
    let currentVideo = document.getElementById('current-video')
    let modalContent = document.querySelector('.modal-content')
    let videoCloseBtn = document.querySelector('.btn-close-video-playback')
    let allPlayBtns = document.querySelectorAll('.play-btn')
  
    const playVideo = (e) => {
      const videoId = e.target.closest("[data-video-id]").getAttribute('data-video-id')
      currentVideo.setAttribute(
        'src',
        `https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1`
      )
      bsModal.show()
    }
  
    const closeVideo = () => {
      currentVideo.removeAttribute('src')
      bsModal.hide()
    }
  
    modalContent.addEventListener('click', closeVideo)
    videoCloseBtn.addEventListener('click', closeVideo)
    allPlayBtns.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        playVideo(e)
      })
    })

    /* Menu Section */
	function onScroll(event) {
		var sections = document.querySelectorAll('.page-scroll');
		var scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

		for (var i = 0; i < sections.length; i++) {
			var currLink = sections[i];
			var val = currLink.getAttribute('href');
			var refElement = document.querySelector(val);
			var scrollTopMinus = scrollPos + 73;
			if (refElement.offsetTop <= scrollTopMinus && (refElement.offsetTop + refElement.offsetHeight > scrollTopMinus)) {
				document.querySelector('.page-scroll').classList.remove('active');
				currLink.classList.add('active');
			} else {
				currLink.classList.remove('active');
			}
		}
	};

    window.document.addEventListener('scroll', onScroll);
    
    // for menu scroll 
    var pageLink = document.querySelectorAll('.page-scroll');

    pageLink.forEach(elem => {
        elem.addEventListener('click', e => {
            e.preventDefault();
            document.querySelector(elem.getAttribute('href')).scrollIntoView({
                behavior: 'smooth',
                offsetTop: 1 - 60,
            });
        });
    });

    // close navbar-collapse when a  clicked
    let navbarToggler = document.querySelector(".navbar-toggler");
    var navbarCollapse = document.querySelector(".collapse");

    document.querySelectorAll(".page-scroll").forEach(e =>
        e.addEventListener("click", () => {
            navbarToggler.classList.remove("active");
            navbarCollapse.classList.remove('show')
        })
    );
    navbarToggler.addEventListener('click', function () {
        navbarToggler.classList.toggle("active");
    })

})();